import { lazy } from 'react';

const RegisterSaleConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/register-sale',
			component: lazy(() => import('./RegisterSaleContainer'))
		}
	]
};

export default RegisterSaleConfig;

